export class UserAuthenticationSingleton {
    static instance
    AccessToken

    constructor() {
        this.AccessToken = ''
    }

    static getInstance() {
        if (!UserAuthenticationSingleton.instance) {
            UserAuthenticationSingleton.instance = new UserAuthenticationSingleton()
        }

        return UserAuthenticationSingleton.instance
    }

    static getAccessToken() {
        const instance = UserAuthenticationSingleton.getInstance()
        return instance.AccessToken
    }

    static setAccessToken(token) {
        const instance = UserAuthenticationSingleton.getInstance()
        instance.AccessToken = token
    }
}
